// import {getUserLoginUrl} from '@/config';

// let $ = typeof window !== 'undefined' ? window.$ : function() {};

// export function updateHeaderVisibility(router) {
//     router.beforeEach((to, from, next) => {
//         if (to.path === '/') {
//             $('body').removeClass('no-header');
//         } else {
//             $('body').addClass('no-header');
//         }
//         next();
//     });
// }

// export function getUserInfoP() {
//     return fetch(getUserLoginUrl(), {
//         credentials: 'include',
//         headers: {
//             'X-Requested-With': 'XMLHttpRequest'
//         }
//     })
//         .then(response => response.json())
//         .then(res => {
//             if (res && res.success && res.data) {
//                 return res.data;
//             } else {
//                 return {
//                     isLogin: false
//                 }
//             }
//         })
//         .catch(err => {
//             console.log(err);
//             return {
//                 message: err,
//                 isLogin: 0
//             }
//         });
// }

export function resizeImage (url, width, height, clip, stretch) {
    let pattern = /^(.*?)(_w\d+_h\d+_c\d+_t\d+)*\.([\w]+)$/;
    let res;

    width = width || 0;
    height = height || 0;
    if (clip === undefined && width > 0 && height > 0) {
        clip = 1;
    }
    clip = clip || 0;
    stretch = stretch || 0;

    if (pattern.exec(url)) {
        res = pattern.exec(url);
        return [
            res[1],
            '_', ['w' + width, 'h' + height, 'c' + clip, 't' + stretch].join('_'),
            '.',
            res[3]
        ].join('');
    }
    return url;
}

export function versionCmp(a, b) {
    if (!a || !b) {
        return -1;
    }
    if (a === b) return 0;
    let arr1 = a.split('.');
    let arr2 = b.split('.');
    return arr1[0] === arr2[0] ? versionCmp(arr1.slice(1).join('.'), arr2.slice(1).join('.')) : +arr1[0] > +arr2[0] ? 1 : -1;
}

export function isIOS11App () {
    if (typeof navigator === 'undefined') {
        return false;
    }
    let UA = navigator.userAgent;
    let isIos = /iphone/i.test(UA);
    if (!isIos || !UA.match(/OS (.*) like Mac OS X/)) {
        return false;
    }
    let iosVersion = UA.match(/OS (.*) like Mac OS X/).length > 1 ? UA.match(/OS (.*) like Mac OS X/)[1] : '10.0.0';
    let isGtIos11 = versionCmp(iosVersion.replace(/_/g, '.'), '11.1.1') >= 0;
    return window.G && window.G.isApp && isIos && isGtIos11;
}

export function goProductUrl (options) {
    options = options || {};
    let oldTemplateProductUrl = '/h5/product/' + options.productId;
    let newTemplateProductUrl = '/wap-mall/item/' + options.productId;
    let url = null;

    let isApp = window.G && window.G.isApp && window.G.versionCmp(window.G.AppVersion, '9.45.0') >= 0;
    let isTuniuWeApp = window.G && window.G.isWeApp;
    // 当地玩乐&目的地参团
    if (options.prdTmpId && options.prdTmpId >= 4) {
      if (isApp) {
        let urlParams = {
          rctModule: 'tnmall',
          rctModuleParams: {
            productId: options.productId
          },
          rctModuleName: 'playLocalDetailRoutes'
        };
        url = 'tuniuapp://page?iosPageName=TNReactNativeViewController&androidPageName=com.tuniu.app.ui.activity.TNReactNativeActivity&parameters=' + encodeURI(JSON.stringify(urlParams));
      } else {
        if (isTuniuWeApp) {
            url = '/mall/pages/details?productId=' + options.productId;
        }else{
            url = newTemplateProductUrl;
        }
      }
    } else if (options.prdTmpId && options.prdTmpId === 3) {
        if (isTuniuWeApp) {
            url = '/mall/pages/details?productId=' + options.productId;
        }else{
            url = newTemplateProductUrl;
        }
    } else {
      url = oldTemplateProductUrl;
    }
    if(options.prdTmpId && options.prdTmpId >= 3 && isTuniuWeApp){
        let UA = navigator.userAgent;
        if (/MicroMessenger\//i.test(UA)) {
            window.wx && window.wx.miniProgram && window.wx.miniProgram.navigateTo({ url });
        } else if (/swan\//i.test(UA)) {
            window.swan && window.swan.webView && window.swan.webView.navigateTo({ url });
        } else if (/toutiaomicroapp\//i.test(UA)) {
            window.tt && window.tt.miniProgram && window.tt.miniProgram.navigateTo({ url });
        }
    }else{
        location.href = url;
    }
  }
  
  



// WEBPACK FOOTER //
// libs/business/global.js